import { useContext } from "react";
import SitePlanContext from "../utils/siteplan-context";
import SETTINGS from "../settings";

import World from "./3d/world";
import Obelisks from "./3d/obelisks";
import BoundaryWall from "./3d/boundaryWall";
import SunPath from "./3d/sun-path";
import TerrainSurface from "./3d/terrain-surface";

import log from "loglevel";

const SunTracker3D = (props) => {
  const sitePlanContext = useContext(SitePlanContext);
  const size = sitePlanContext.heightMap.boundBox.size;

  return (
    <World
      latitude={sitePlanContext.boundBox.north}
      size={Math.max(size.x, size.y)}
      controlData={props.controlData}
    >
      <TerrainSurface heightMap={sitePlanContext.heightMap} />
      <Obelisks
        heightMap={sitePlanContext.heightMap}
        poiMarkers={sitePlanContext.poiMarkers}
      />
      <BoundaryWall
        heightMap={sitePlanContext.heightMap}
        sitePlanCoords={sitePlanContext.sitePlanCoords}
      />
      <SunPath heightMap={sitePlanContext.heightMap} />
    </World>
  );
};

export default React.memo(SunTracker3D);
